export default __webpack_public_path__ + "static/media/lynn-artworkinfo3.68e023eb.png";